import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { GrAdd } from 'react-icons/gr'
import ExpandableCard from 'components/expandable-card'
import AppContext from 'context'
import colors from 'utils/colors'
import WP_DATA from 'utils/wp_data'

const defaultFields = WP_DATA.worksheet_type === 'cashflow-analysis' 
  ? {
    current: 0,
    projected: 0,
    frequency: 'Monthly',
    notes: '',  
  } : {
    self: 0,
    spouse: 0,
    joint: 0,
    notes: '',
  }

const AddNew = ({ sectionId }) => {
  const { dispatch } = useContext(AppContext)
  const [title, setTitle] = useState('')
  const [newItemFields, setNewItemFields] = useState({})
  const [err, setErr] = useState(false)
  
  useEffect(() => {
    if (sectionId === 'Loans') {
      setNewItemFields({
        ...defaultFields,
        interest_rate: 0,
        years_remaining: 0,
        outstanding_balance: 0,
        fixed_or_variable: 'Fixed',
        terms: '',
      })
    } else {
      setNewItemFields(defaultFields)
    }
  }, [sectionId]) 

  const handleSave = () => {
    setErr(false)
    if (title.length > 3) {

      if (sectionId === 'Loans') {
        newItemFields.interest_rate = 0
        newItemFields.years_remaining = 0
        newItemFields.outstanding_balance = 0
        newItemFields.fixed_or_variable = 'Fixed'
        newItemFields.terms = ''
      }

      dispatch({
        type: 'ADD_NEW',
        payload: {
          sectionId,
          title,
          fields: newItemFields
        }
      })
      setTitle('')
      setNewItemFields(defaultFields)
    } else {
      setErr('Your title must be more than 3 characters long.')
    }
  }

  return (
    <>
      <ExpandableCard
        header={
          <h4 style={{textAlign: 'center'}}>
            <GrAdd /> {title === '' ? 'Add New' : title}
          </h4>
        }
        icon={<GrAdd />}
        sectionId={sectionId}
      >
        <>
          <label>
            Title<br/>
            <input name="title" value={title} onChange={e => setTitle(e.target.value)} type="text" placeholder="New title" />
          </label>
          <button className="btn btn-primary" type="button" onClick={handleSave}>Save</button>
          {err && <p style={{ color: colors.red }}>{err}</p>}
        </>
      </ExpandableCard>
    </>
  )
}

export default AddNew

AddNew.propTypes = {
  sectionId: PropTypes.string.isRequired,
}